export const TESTS_API_TAGS = {
  GROUP_TAG: 'Group',
  TEST_TAG: 'Test',
  TESTS_LIST_TAG: 'TestsList',
} as const;
